export default __webpack_public_path__ + "static/media/19.90e40131.jpg";